import { render, staticRenderFns } from "./recommendCourse.vue?vue&type=template&id=1d00bfc9&scoped=true"
import script from "./recommendCourse.vue?vue&type=script&lang=js"
export * from "./recommendCourse.vue?vue&type=script&lang=js"
import style0 from "./recommendCourse.vue?vue&type=style&index=0&id=1d00bfc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00bfc9",
  null
  
)

export default component.exports